module.exports = __webpack_public_path__ + "img/Bic_Camera_JP.56b062d4.png";